<template>
  <a-modal
    class="users-in-active-strategies__modal"
    :visible="visible"
    :bodyStyle="{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '32px',
    }"
    @cancel="handleClose"
  >
    <component :is="QuestionCircleOutlined" class="icon" />

    <div class="info">
      <h5 class="info info__title">¿Estás seguro de {{ modalAction }} “{{ chatbot.name }}”?</h5>

      <p class="info info__description">
        Recuerda que este chatbot actualmente cuenta con
        <strong>
          {{ totalTickets }}
          {{ totalTickets === 1 ? "ticket activo" : "tickets activos" }},
        </strong>
        por eso es necesario que escojas una acción a realizar.
      </p>
    </div>

    <a-radio-group v-model:value="actionType">
      <a-radio class="items-space" :value="1">
        Transferir todos los tickets a la cola seleccionada

        <a-tooltip title="Pasarán a ser atendidos por los usuarios asignados a la cola">
          <InfoCircleOutlined />
        </a-tooltip>
      </a-radio>

      <a-form layout="vertical" :model="formState">
        <CampaignPicker
          chatbot-picker
          default-behavior
          with-out-entity
          with-name
          :disabled="actionType !== 1"
          :show-all="false"
          label="Selecciona una campaña"
          :value="formState.portfolio"
          @update:value="formState.portfolio = $event"
        />

        <QueuePicker
          default-behavior
          with-out-portfolio
          :show-all="false"
          :portfolio="formState.portfolio"
          v-model:value="formState.queue"
        >
          <template #label>
            Selecciona una cola

            <a-tooltip title="Se listarán solo aquellas colas asociadas a la campaña seleccionada.">
              <InfoCircleOutlined style="margin-left: 5px" />
            </a-tooltip>
          </template>
        </QueuePicker>
      </a-form>
      <!-- <a-table
        class="items-space"
        :dataSource="chatbot.channels_customers"
        :columns="columns"
        :pagination="{ pageSize: 5 }"
      >
        <template #channel="{ record }">
          <span> {{ record.associate }} </span>
          <span v-if="record.provider_name"> ({{ record.provider_name }}) </span>
        </template>

        <template #queue="{ record }">
          {{ record.queues?.[0]?.name }}
        </template>
      </a-table> -->

      <a-radio :value="2">Finalizar todos los tickets </a-radio>
    </a-radio-group>

    <a-button type="primary" class="modal__button" @click="handleAction">
      {{ modalAction }} chatbot
    </a-button>
  </a-modal>
</template>

<script setup>
import { ref, reactive, watch } from "vue";
import { QuestionCircleOutlined, InfoCircleOutlined } from "@ant-design/icons-vue";

import { changeChatbotStatus } from "@/app/chatbots/services";
import { ChatbotStatus } from "@/app/chatbots/utils/enums";

import CampaignPicker from "@/app/shared/components/pickers/CampaignPicker.vue";
import QueuePicker from "@/app/shared/components/pickers/QueuePicker.vue";
import { message } from "ant-design-vue";

// const columns = [
//   {
//     title: "Canales asignados",
//     key: "associate",
//     dataIndex: "associate",
//     slots: { customRender: "channel" },
//     ellipsis: true,
//   },
//   {
//     title: "Cola",
//     key: "queue",
//     dataIndex: "queue",
//     slots: { customRender: "queue" },
//     ellipsis: true,
//   },
// ];

const props = defineProps({
  visible: {
    required: true,
    type: Boolean,
  },
  chatbot: {
    required: true,
    type: Object,
  },
  totalTickets: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(["update, close"]);

const modalAction = "inactivar";

const actionType = ref(1);
const formState = reactive({
  portfolio: null,
  queue: null,
});

const handleAction = async () => {
  const body = {
    status: ChatbotStatus.Inactive,
    type: actionType.value,
  };

  if (body.type === 1) {
    body.portfolio = formState.portfolio;
    body.queue = formState.queue;
  }

  try {
    await changeChatbotStatus(props.chatbot.id, body);
  } catch (error) {
    const errorMessage = error?.getErrorMessage() || "Error al deshabilitar";
    message.error(errorMessage);

    console.log(error);
  }
  emit("update");
  handleClose();
};

const handleClose = () => {
  emit("close");
};

watch(actionType, () => {
  if (actionType.value === 2) formState.portfolio = null;
});
</script>

<style lang="sass" scoped>
:deep(.ant-modal-header)
  display: none

.icon
  font-size: 52px
  color: $gold-6
  display: block

.delete-icon
  color: $red-6

.info
  color: $gray-13
  margin: 0

  &__title
    font-size: 16px
    font-weight: 600
    margin: 15px 0 12px
    text-align: center

  &__description
    font-size: 14px
    margin-bottom: 20px

.items-space
  margin-bottom: 12px
.modal__button
  width: 100%
  margin-top: 20px
  text-transform: capitalize
</style>

<style>
.users-in-active-strategies__modal .ant-modal-footer {
  display: none !important;
}

.users-in-active-strategies__modal
  .ant-table-tbody
  > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
  > td {
  background-color: #feffe6;
}
</style>
